import React from "react"
import PropTypes from "prop-types"
import "sanitize.css"
import "../styles/style.scss"
import { injectIntl } from "gatsby-plugin-intl"

const Layout = ({ children }) => {

  return (
    <main>{children}</main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default injectIntl(Layout)
